import { render, staticRenderFns } from "./HomeFooter.vue?vue&type=template&id=bf06c9e4&scoped=true&"
import script from "./HomeFooter.vue?vue&type=script&lang=js&"
export * from "./HomeFooter.vue?vue&type=script&lang=js&"
import style0 from "./HomeFooter.vue?vue&type=style&index=0&id=bf06c9e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf06c9e4",
  null
  
)

export default component.exports